
import { defineComponent } from "vue";

export default defineComponent({
  name: "TermsAndConditions",
  props: {
    closed: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      terms: [
        "We use cookies and other tracking technologies to improve your browsing experience, to show you personalized content, to analyze our website traffic and to monitor where our visitors are coming from.",
        "By using this tool, **you consent** to our use of cookies and other tracking technologies.",
        'This app does **not** store personal data about *you*. The app\'s <em style="color: #fff">"memory"</em>&nbsp;&nbsp;is your browser storage and can be wiped clean at any time by clearing cookies for the current domain.',
      ],
    };
  },
});
